import { Injectable } from '@angular/core';
import {  HttpGeneralService} from '../../../shared/shared';
import { CONFIG } from '../../../shared/config';
import {Village} from './village';
let villagesUrl = CONFIG.baseUrls.villages;




@Injectable()
export class VillageService {
    constructor(private httpGeneralService: HttpGeneralService) {
        //this._messageService.state.subscribe(state => this.getVillages());
    }

    searchVillages(k?: string, paramObj?: any) {
        return this.httpGeneralService.search(k, villagesUrl)
    }

    getVillages(serial: number = 0) {

        return this.httpGeneralService.get(serial, villagesUrl)
    }

    addVillage(village: Village) {

        return this.httpGeneralService.add<Village>(village, villagesUrl)
    }



    getVillage(id: number) {
        return this.httpGeneralService.get(id, villagesUrl)
    }


    updateVillage(village: Village) {

        return this.httpGeneralService.update<Village>(village.code, village, villagesUrl)
    }

    deleteVillage(village: Village) {

        return this.httpGeneralService.delete<number>(village.code, `${villagesUrl}`)
     
    }


}
